<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-layout>
          <v-flex>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <!-- <v-flex text-right>
            <v-btn @click="openNewBusinessDialog" depressed color="primary">
              Create New E
            </v-btn>
          </v-flex> -->
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="entities"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <!-- <new-business-dialog ref="newBusinessDialog" /> -->
    <edit-entity-dialog :details="editedItem" ref="editEntityDialog" />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import EditEntityDialog from "../components/EditEntityDialog";

import moment from "moment";
export default {
  components: { EditEntityDialog },
  data() {
    return {
      search: "",
      dialogDelete: false,
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        { text: "Category", value: "categoryName" },
        // { text: "Type", value: "entityType" },
        { text: "State", value: "state" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
      editedIndex: -1,
      defaultItem: {
        name: "",
        latitude: "",
        longitude: "",
      },
    };
  },
  computed: {
    ...mapState("$_entity", ["entities"]),
  },
  created() {
    this.getEntities({
      collection: "entities",
      condition: {
        leftVal: "state",
        operator: "==",
        rightVal: "in-review",
      },
      mutation: "updateEntities",
    });
  },
  methods: {
    ...mapActions({
      getEntities: "$_entity/getContent",
      deleteEntity: "$_entity/deleteContent",
    }),
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    editItem(item) {
      this.editedIndex = this.entities.indexOf(item);
      this.editedItem = Object.assign({}, this.entities[this.editedIndex]);

      console.log("Edited Item: ", this.editedItem);

      this.$refs.editEntityDialog.toggleDialog(this.editedItem);
    },
    deleteItem(item) {
      this.editedIndex = this.entities.indexOf(item);
      this.itemToDelete = Object.assign({}, this.entities[this.editedIndex]);
      this.dialogDelete = true;

      console.log(item);
    },
    deleteItemConfirm() {
      this.deleteEntity({
        details: this.itemToDelete,
        collection: "entities",
        type: "Entity",
      }).then(() => {
        this.dialogDelete = false;
        this.getEntities({
          collection: "entities",
          condition: {
            leftVal: "state",
            operator: "==",
            rightVal: "in-review",
          },
          mutation: "updateEntities",
        });
      });
    },
  },
};
</script>

<style>
</style>